import globals from "./globals";
import { getBool, setBool } from "utilities";
import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        var target = $("[data-toggle]");

        if (target.length) {
            if (globals.debug) console.log("component-toggle initialized");

            target.on("click", function (_e) {
                var eventTarget = $(this);
                var toggleState = getBool(eventTarget.attr("data-toggle"));
                var toggleTarget = eventTarget.attr("data-target");

                eventTarget.attr("data-toggle", setBool(!toggleState));

                if (toggleTarget) {
                    var toggleScope = eventTarget.attr("data-scope") || "body";
                    eventTarget.parents(toggleScope).find(toggleTarget).attr("data-state", setBool(!toggleState));
                }
            });
        }
    });
})();

export default component;
